import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20artistic%20illustration%20with%20abstract%20flowing%20ink%20and%20warm%20gradient%20colors%2C%20dreamy%20atmosphere%2C%20soft%20coral%20and%20amber%20color%20palette%2C%20elegant%20minimal%20composition%2C%20subtle%20comic%20panel%20elements%2C%20artistic%20digital%20painting%20style%2C%20warm%20light%20background&width=1920&height=800&seq=hero-bg-korean-comic&orientation=landscape"
        alt="韩漫之家 - 韩国漫画免费在线阅读"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/20 to-foreground-950/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
          发现你的<span className="text-primary-400">下一部</span>最爱韩漫
        </h1>
        <p className="text-background-200 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          韩漫之家提供海量韩国漫画免费在线阅读，下拉式流畅体验，从浪漫爱情到热血动作，精选好看的漫画大全，随时随地畅享精彩故事
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/romance"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/25 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        {/* Stats */}
        <div className="flex items-center justify-center gap-8 md:gap-12 mt-12">
          {[
            { value: '500+', label: '精选漫画' },
            { value: '50,000+', label: '更新章节' },
            { value: '100万+', label: '忠实读者' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}